export const GETRECRUITER_REQUEST = 'GetRecruiterReducer/GETRECRUITER_REQUEST';
export const GETRECRUITER_SUCCESS = 'GetRecruiterReducer/GETRECRUITER_SUCCESS';
export const GETRECRUITER_FAILED = 'GetRecruiterReducer/GETRECRUITER_FAILED';
export const GETLISTRECRUITER_REQUEST = 'GetListRecruiterReducer/GETLISTRECRUITER_REQUEST';
export const GETLISTRECRUITER_SUCCESS = 'GetListRecruiterReducer/GETLISTRECRUITER_SUCCESS';
export const GETLISTRECRUITER_FAILED = 'GetListRecruiterReducer/GETLISTRECRUITER_FAILED';
export const GETLISTREVIEW_REQUEST = 'GetListReviewReducer/GETLISTREVIEW_REQUEST';
export const GETLISTREVIEW_SUCCESS = 'GetListReviewReducer/GETLISTREVIEW_SUCCESS';
export const GETLISTREVIEW_FAILED = 'GetListReviewRducer/GETLISTREVIEW_FAILED';